import { contentType, pageTypes } from '../constants/global';
import configData from '../config';
import getPageHierarchy from './url-manager/urlHierarchyHelper';

export default function transformDataIntoObject(
  type,
  locale,
  pageURL,
  title,
  gtin,
  productName
) {
  let pageData = null;
  const PGDataLayer = require(`../data/${locale}/pgDataLayer.json`);

  if (PGDataLayer) {
    // Reseting the Object because object will have previous page values when visiting new page.
    PGDataLayer.content.category = '';
    PGDataLayer.content.type = '';
    PGDataLayer.product.category = '';
    PGDataLayer.product.gtin = '';
    PGDataLayer.product.name = '';
    PGDataLayer.product['sub-brand'] = '';
    PGDataLayer.event[0].category = '';
    PGDataLayer.event[0].action = '';

    switch (type) {
      case contentType.productPage:
        // The snippet of code extracts the breadcrumb titles and pushed them into an array.
        if (pageURL && locale) {
          pageData = getPageHierarchy(pageURL, locale);
          PGDataLayer.content.category = pageData[1]
            ? pageData[1].breadCrumbTitle
            : '';
          PGDataLayer.content.type = pageTypes.PRODUCT;
          PGDataLayer.event[0].category = 'event_informational_action';
          PGDataLayer.event[0].action = 'event_view_product_detail_page';
          PGDataLayer.event[0].label = 'product-detail';
          PGDataLayer.product.category = pageData[1]
            ? pageData[1].breadCrumbTitle
            : '';
          PGDataLayer.product.gtin = gtin;
          PGDataLayer.product.name = productName;
          PGDataLayer.product['sub-brand'] = pageData[2]
            ? pageData[2].breadCrumbTitle
            : '';
        }
        break;
      case contentType.homePage:
        PGDataLayer.content.type = pageTypes.HOME;
        break;
      case contentType.contentPage:
        PGDataLayer.content.type = pageTypes.CONTENT_PAGE;
        break;
      case contentType.login:
        PGDataLayer.content.type = pageTypes.LOGIN;
        break;
      case contentType.registration:
        PGDataLayer.content.type = pageTypes.REGISTRATION;
        break;
      case contentType.editProfile:
        PGDataLayer.content.type = pageTypes.EDITPROFILE;
        PGDataLayer.event[0].category = 'event_crm_action';
        PGDataLayer.event[0].action = 'event_profile_login_complete';
        PGDataLayer.event[0].label = 'event_successful_login';
        break;
      case contentType.articlePage:
        if (pageURL && locale) {
          pageData = getPageHierarchy(pageURL, locale);
          PGDataLayer.content.category = pageData[1]
            ? pageData[1].breadCrumbTitle
            : '';
          PGDataLayer.content.type = pageTypes.ARTICLE;
          PGDataLayer.event[0].category = 'event_informational_action';
          PGDataLayer.event[0].action = 'event_view_article_page';
          PGDataLayer.event[0].label = 'article-detail';
        }
        break;
      case contentType.articleListPage:
        if (pageURL && locale) {
          pageData = getPageHierarchy(pageURL, locale);
          PGDataLayer.content.category = pageData[1]
            ? pageData[1].breadCrumbTitle
            : '';
          PGDataLayer.content.type = pageTypes.ARTICLE_LISTING;
        }
        break;
      default:
        break;
  }

    PGDataLayer.page.url = pageURL;
    PGDataLayer.page.title = title;
    console.log('process.env.GTM_PT_BR_SEGMENT', process.env.GTM_PT_BR_SEGMENT)
    PGDataLayer.updated = true;
    // Below Condition checks if object is already present. If yes, then skip redundant assignment of the object.
    if (!PGDataLayer.GTM) {
      PGDataLayer.GTM = { ...configData.GTM[locale] };
      PGDataLayer.GTM.Segment = process.env.GTM_PT_BR_SEGMENT;
      PGDataLayer.GTM.Rudderstack = process.env.GTM_RUDDERSTACK;
    }
  }
  return PGDataLayer;
}
